export default __webpack_public_path__ + "static/media/verified.8592370a.gif";